import React from 'react'
import CartItems from '../components/cart-items/CartItems'

const Cart = () => {
  return (
    <div>
      <CartItems/>
    </div>
  )
}

export default Cart
